import { OrderStatesEnum } from "./pages/orders/enums/order-states.enum";
import { InWarehouseActionTypes } from "./management-pages/actions/action-types.enum";

export const ARMENIA_COUNTRY_ID = 1;
export const POLAND_COUNTRY_ID = 4;

export const statesWithLocation = [
  OrderStatesEnum.inWarehouse,
  OrderStatesEnum.inIntermediateWarehouse,
  OrderStatesEnum.inLocalWarehouse,
  OrderStatesEnum.readyForShipment,
  OrderStatesEnum.unidentified,
  OrderStatesEnum.toBeDelivered,
  OrderStatesEnum.readyForPickup,
] as (number | string)[];
export const statesWithTabs = [
  ...statesWithLocation,
  OrderStatesEnum.onTheWay,
] as (number | string)[];

export const actionsWithPreOpenedAdditionalDialogs: any[] = [
  InWarehouseActionTypes.SELECT_LOCATION_AND_ADD_ORDERS,
];

export const supportedLanguages = ["hy", "ru", "pl", "en"];
export const collectionNames = ["orders", "users"];

export const STATUSES = ["Enabled", "Disabled"];

export enum CHECKBOX_STATUS {
  ON = 'on',
  OFF = 'off'
}
